import {styled} from "@mui/material/styles"

export const StandardChevronImage = styled("img", {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<{$isFilterOpen: boolean}>`
    transform: rotate(${({$isFilterOpen}) => ($isFilterOpen ? `180` : `0`)}deg);
    transition: transform 0.2s;
    margin-left: auto;
`

export default StandardChevronImage
